import React, { Fragment, PureComponent } from 'react';
import { RegionAvailability } from '~/MedicinalBrandsAnalytics/Region';
import Availability from '~/MedicinalBrandsAnalytics/VirtualBrand/Availability';

import styles from './styles.less';

interface Props {
	availability: { [key: string]: any[] };
	regionAvailabilities: RegionAvailability[] | null;
}

export default class AvailabilityList extends PureComponent<Props> {
	render() {
		const { regionAvailabilities } = this.props;
		if (!regionAvailabilities) {
			return null;
		}

		return (
			<div className={styles.content}>
				<div className={styles.leftColumn}>{this.renderList(regionAvailabilities.slice(0, 1))}</div>
				<div className={styles.rightColumn}>{this.renderList(regionAvailabilities.slice(1))}</div>
			</div>
		);
	}

	renderList(regionAvailabilities: RegionAvailability[]) {
		const { availability } = this.props;

		return (
			<div className={styles.region}>
				{regionAvailabilities.map((regionAvailability) => (
					<Fragment key={regionAvailability.region.id}>
						<div className={styles.regionContent}>
							<div className={styles.regionTitle}>{regionAvailability.region.title}</div>
							<div className={styles.regionCount}>
								<Availability availability={availability} countries={regionAvailability.countries} />
							</div>
							<div className={styles.subRegions}>{this.renderList(regionAvailability.subRegions)}</div>
						</div>
					</Fragment>
				))}
			</div>
		);
	}
}
